/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Channel,
  ChannelMeterRow,
  Connection,
  DeviceContractByMeter200,
  DeviceObject,
  DeviceObjectUpdateRequest,
  DevicesChannelsFlatParams,
  DevicesListParams,
  ErrorResponse,
  Feeder,
  FeederUpdateRequest,
  Region
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List devices (objects)
 */
export const devicesList = (
    params?: DevicesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DeviceObject[]>(
      {url: `/api/devices`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getDevicesListQueryKey = (params?: DevicesListParams,) => {
    return [
    `/api/devices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDevicesListQueryOptions = <TData = Awaited<ReturnType<typeof devicesList>>, TError = ErrorResponse>(params?: DevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesList>>> = ({ signal }) => devicesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesList>>>
export type DevicesListQueryError = ErrorResponse


export function useDevicesList<TData = Awaited<ReturnType<typeof devicesList>>, TError = ErrorResponse>(
 params: undefined |  DevicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesList>>,
          TError,
          Awaited<ReturnType<typeof devicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesList<TData = Awaited<ReturnType<typeof devicesList>>, TError = ErrorResponse>(
 params?: DevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesList>>,
          TError,
          Awaited<ReturnType<typeof devicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesList<TData = Awaited<ReturnType<typeof devicesList>>, TError = ErrorResponse>(
 params?: DevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List devices (objects)
 */

export function useDevicesList<TData = Awaited<ReturnType<typeof devicesList>>, TError = ErrorResponse>(
 params?: DevicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get device object by ID
 */
export const devicesGet = (
    regionId: number,
    objectId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DeviceObject>(
      {url: `/api/devices/${regionId}/${objectId}`, method: 'GET', signal
    },
      options);
    }
  



export const getDevicesGetQueryKey = (regionId?: number,
    objectId?: number,) => {
    return [
    `/api/devices/${regionId}/${objectId}`
    ] as const;
    }

    
export const getDevicesGetQueryOptions = <TData = Awaited<ReturnType<typeof devicesGet>>, TError = ErrorResponse>(regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesGetQueryKey(regionId,objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesGet>>> = ({ signal }) => devicesGet(regionId,objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId && objectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesGetQueryResult = NonNullable<Awaited<ReturnType<typeof devicesGet>>>
export type DevicesGetQueryError = ErrorResponse


export function useDevicesGet<TData = Awaited<ReturnType<typeof devicesGet>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesGet>>,
          TError,
          Awaited<ReturnType<typeof devicesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesGet<TData = Awaited<ReturnType<typeof devicesGet>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesGet>>,
          TError,
          Awaited<ReturnType<typeof devicesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesGet<TData = Awaited<ReturnType<typeof devicesGet>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get device object by ID
 */

export function useDevicesGet<TData = Awaited<ReturnType<typeof devicesGet>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesGetQueryOptions(regionId,objectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update device object (address and contract)
 */
export const devicesUpdate = (
    regionId: number,
    objectId: number,
    deviceObjectUpdateRequest: DeviceObjectUpdateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/devices/${regionId}/${objectId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: deviceObjectUpdateRequest
    },
      options);
    }
  


export const getDevicesUpdateMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesUpdate>>, TError,{regionId: number;objectId: number;data: DeviceObjectUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesUpdate>>, TError,{regionId: number;objectId: number;data: DeviceObjectUpdateRequest}, TContext> => {

const mutationKey = ['devicesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesUpdate>>, {regionId: number;objectId: number;data: DeviceObjectUpdateRequest}> = (props) => {
          const {regionId,objectId,data} = props ?? {};

          return  devicesUpdate(regionId,objectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesUpdate>>>
    export type DevicesUpdateMutationBody = DeviceObjectUpdateRequest
    export type DevicesUpdateMutationError = ErrorResponse

    /**
 * @summary Update device object (address and contract)
 */
export const useDevicesUpdate = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesUpdate>>, TError,{regionId: number;objectId: number;data: DeviceObjectUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesUpdate>>,
        TError,
        {regionId: number;objectId: number;data: DeviceObjectUpdateRequest},
        TContext
      > => {

      const mutationOptions = getDevicesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update feeder fields (cod_kre, feeder_name)
 */
export const updateFeeder = (
    regionId: number,
    objectId: number,
    feederID: number,
    feederUpdateRequest: FeederUpdateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/devices/${regionId}/${objectId}/feeders/${feederID}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: feederUpdateRequest
    },
      options);
    }
  


export const getUpdateFeederMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeeder>>, TError,{regionId: number;objectId: number;feederID: number;data: FeederUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFeeder>>, TError,{regionId: number;objectId: number;feederID: number;data: FeederUpdateRequest}, TContext> => {

const mutationKey = ['updateFeeder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFeeder>>, {regionId: number;objectId: number;feederID: number;data: FeederUpdateRequest}> = (props) => {
          const {regionId,objectId,feederID,data} = props ?? {};

          return  updateFeeder(regionId,objectId,feederID,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFeederMutationResult = NonNullable<Awaited<ReturnType<typeof updateFeeder>>>
    export type UpdateFeederMutationBody = FeederUpdateRequest
    export type UpdateFeederMutationError = ErrorResponse

    /**
 * @summary Update feeder fields (cod_kre, feeder_name)
 */
export const useUpdateFeeder = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeeder>>, TError,{regionId: number;objectId: number;feederID: number;data: FeederUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFeeder>>,
        TError,
        {regionId: number;objectId: number;feederID: number;data: FeederUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateFeederMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get contract linked to a specific meter
 */
export const deviceContractByMeter = (
    regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DeviceContractByMeter200>(
      {url: `/api/devices/${regionId}/${objectId}/feeders/${feederID}/meters/${meterNumber}/contract`, method: 'GET', signal
    },
      options);
    }
  



export const getDeviceContractByMeterQueryKey = (regionId?: number,
    objectId?: number,
    feederID?: number,
    meterNumber?: string,) => {
    return [
    `/api/devices/${regionId}/${objectId}/feeders/${feederID}/meters/${meterNumber}/contract`
    ] as const;
    }

    
export const getDeviceContractByMeterQueryOptions = <TData = Awaited<ReturnType<typeof deviceContractByMeter>>, TError = ErrorResponse>(regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeviceContractByMeterQueryKey(regionId,objectId,feederID,meterNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof deviceContractByMeter>>> = ({ signal }) => deviceContractByMeter(regionId,objectId,feederID,meterNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId && objectId && feederID && meterNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeviceContractByMeterQueryResult = NonNullable<Awaited<ReturnType<typeof deviceContractByMeter>>>
export type DeviceContractByMeterQueryError = ErrorResponse


export function useDeviceContractByMeter<TData = Awaited<ReturnType<typeof deviceContractByMeter>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deviceContractByMeter>>,
          TError,
          Awaited<ReturnType<typeof deviceContractByMeter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeviceContractByMeter<TData = Awaited<ReturnType<typeof deviceContractByMeter>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deviceContractByMeter>>,
          TError,
          Awaited<ReturnType<typeof deviceContractByMeter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeviceContractByMeter<TData = Awaited<ReturnType<typeof deviceContractByMeter>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get contract linked to a specific meter
 */

export function useDeviceContractByMeter<TData = Awaited<ReturnType<typeof deviceContractByMeter>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number,
    meterNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deviceContractByMeter>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeviceContractByMeterQueryOptions(regionId,objectId,feederID,meterNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List all regions
 */
export const devicesRegions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Region[]>(
      {url: `/api/devices/regions`, method: 'GET', signal
    },
      options);
    }
  



export const getDevicesRegionsQueryKey = () => {
    return [
    `/api/devices/regions`
    ] as const;
    }

    
export const getDevicesRegionsQueryOptions = <TData = Awaited<ReturnType<typeof devicesRegions>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesRegionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesRegions>>> = ({ signal }) => devicesRegions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof devicesRegions>>>
export type DevicesRegionsQueryError = ErrorResponse


export function useDevicesRegions<TData = Awaited<ReturnType<typeof devicesRegions>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesRegions>>,
          TError,
          Awaited<ReturnType<typeof devicesRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesRegions<TData = Awaited<ReturnType<typeof devicesRegions>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesRegions>>,
          TError,
          Awaited<ReturnType<typeof devicesRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesRegions<TData = Awaited<ReturnType<typeof devicesRegions>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all regions
 */

export function useDevicesRegions<TData = Awaited<ReturnType<typeof devicesRegions>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesRegionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Search channels flat (across all feeders)
 */
export const devicesChannelsFlat = (
    params?: DevicesChannelsFlatParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ChannelMeterRow[]>(
      {url: `/api/devices/channels`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getDevicesChannelsFlatQueryKey = (params?: DevicesChannelsFlatParams,) => {
    return [
    `/api/devices/channels`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDevicesChannelsFlatQueryOptions = <TData = Awaited<ReturnType<typeof devicesChannelsFlat>>, TError = ErrorResponse>(params?: DevicesChannelsFlatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesChannelsFlatQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesChannelsFlat>>> = ({ signal }) => devicesChannelsFlat(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesChannelsFlatQueryResult = NonNullable<Awaited<ReturnType<typeof devicesChannelsFlat>>>
export type DevicesChannelsFlatQueryError = ErrorResponse


export function useDevicesChannelsFlat<TData = Awaited<ReturnType<typeof devicesChannelsFlat>>, TError = ErrorResponse>(
 params: undefined |  DevicesChannelsFlatParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesChannelsFlat>>,
          TError,
          Awaited<ReturnType<typeof devicesChannelsFlat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesChannelsFlat<TData = Awaited<ReturnType<typeof devicesChannelsFlat>>, TError = ErrorResponse>(
 params?: DevicesChannelsFlatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesChannelsFlat>>,
          TError,
          Awaited<ReturnType<typeof devicesChannelsFlat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesChannelsFlat<TData = Awaited<ReturnType<typeof devicesChannelsFlat>>, TError = ErrorResponse>(
 params?: DevicesChannelsFlatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search channels flat (across all feeders)
 */

export function useDevicesChannelsFlat<TData = Awaited<ReturnType<typeof devicesChannelsFlat>>, TError = ErrorResponse>(
 params?: DevicesChannelsFlatParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannelsFlat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesChannelsFlatQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List feeders for a device object
 */
export const devicesFeeders = (
    regionId: number,
    objectId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Feeder[]>(
      {url: `/api/devices/${regionId}/${objectId}/feeders`, method: 'GET', signal
    },
      options);
    }
  



export const getDevicesFeedersQueryKey = (regionId?: number,
    objectId?: number,) => {
    return [
    `/api/devices/${regionId}/${objectId}/feeders`
    ] as const;
    }

    
export const getDevicesFeedersQueryOptions = <TData = Awaited<ReturnType<typeof devicesFeeders>>, TError = ErrorResponse>(regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesFeedersQueryKey(regionId,objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesFeeders>>> = ({ signal }) => devicesFeeders(regionId,objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId && objectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesFeedersQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFeeders>>>
export type DevicesFeedersQueryError = ErrorResponse


export function useDevicesFeeders<TData = Awaited<ReturnType<typeof devicesFeeders>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesFeeders>>,
          TError,
          Awaited<ReturnType<typeof devicesFeeders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesFeeders<TData = Awaited<ReturnType<typeof devicesFeeders>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesFeeders>>,
          TError,
          Awaited<ReturnType<typeof devicesFeeders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesFeeders<TData = Awaited<ReturnType<typeof devicesFeeders>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List feeders for a device object
 */

export function useDevicesFeeders<TData = Awaited<ReturnType<typeof devicesFeeders>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeeders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesFeedersQueryOptions(regionId,objectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List channels for a feeder
 */
export const devicesChannels = (
    regionId: number,
    objectId: number,
    feederID: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Channel[]>(
      {url: `/api/devices/${regionId}/${objectId}/feeders/${feederID}/channels`, method: 'GET', signal
    },
      options);
    }
  



export const getDevicesChannelsQueryKey = (regionId?: number,
    objectId?: number,
    feederID?: number,) => {
    return [
    `/api/devices/${regionId}/${objectId}/feeders/${feederID}/channels`
    ] as const;
    }

    
export const getDevicesChannelsQueryOptions = <TData = Awaited<ReturnType<typeof devicesChannels>>, TError = ErrorResponse>(regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesChannelsQueryKey(regionId,objectId,feederID);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesChannels>>> = ({ signal }) => devicesChannels(regionId,objectId,feederID, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId && objectId && feederID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof devicesChannels>>>
export type DevicesChannelsQueryError = ErrorResponse


export function useDevicesChannels<TData = Awaited<ReturnType<typeof devicesChannels>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesChannels>>,
          TError,
          Awaited<ReturnType<typeof devicesChannels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesChannels<TData = Awaited<ReturnType<typeof devicesChannels>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesChannels>>,
          TError,
          Awaited<ReturnType<typeof devicesChannels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesChannels<TData = Awaited<ReturnType<typeof devicesChannels>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List channels for a feeder
 */

export function useDevicesChannels<TData = Awaited<ReturnType<typeof devicesChannels>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesChannels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesChannelsQueryOptions(regionId,objectId,feederID,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List connections linked to feeder's meters
 */
export const devicesFeederConnections = (
    regionId: number,
    objectId: number,
    feederID: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Connection[]>(
      {url: `/api/devices/${regionId}/${objectId}/feeders/${feederID}/connections`, method: 'GET', signal
    },
      options);
    }
  



export const getDevicesFeederConnectionsQueryKey = (regionId?: number,
    objectId?: number,
    feederID?: number,) => {
    return [
    `/api/devices/${regionId}/${objectId}/feeders/${feederID}/connections`
    ] as const;
    }

    
export const getDevicesFeederConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof devicesFeederConnections>>, TError = ErrorResponse>(regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesFeederConnectionsQueryKey(regionId,objectId,feederID);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesFeederConnections>>> = ({ signal }) => devicesFeederConnections(regionId,objectId,feederID, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId && objectId && feederID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesFeederConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFeederConnections>>>
export type DevicesFeederConnectionsQueryError = ErrorResponse


export function useDevicesFeederConnections<TData = Awaited<ReturnType<typeof devicesFeederConnections>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesFeederConnections>>,
          TError,
          Awaited<ReturnType<typeof devicesFeederConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesFeederConnections<TData = Awaited<ReturnType<typeof devicesFeederConnections>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesFeederConnections>>,
          TError,
          Awaited<ReturnType<typeof devicesFeederConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesFeederConnections<TData = Awaited<ReturnType<typeof devicesFeederConnections>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List connections linked to feeder's meters
 */

export function useDevicesFeederConnections<TData = Awaited<ReturnType<typeof devicesFeederConnections>>, TError = ErrorResponse>(
 regionId: number,
    objectId: number,
    feederID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesFeederConnections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesFeederConnectionsQueryOptions(regionId,objectId,feederID,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




